import axios from 'axios';
import  {API_HOST} from "configs/api";
import auth from 'utils/auth';

const publicFetch = axios.create({
    baseURL: API_HOST
  });

publicFetch.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
  );

const customFetch = axios.create({
    baseURL: API_HOST
});

customFetch.defaults.headers.common["Authorization"] = `${auth.getCustomToken()}`;
  
export { publicFetch, customFetch };